import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { commonPostApi } from "../../utils/apiService";
import "./Login.scss";
import loginImage from "../../assets/images/login-image.png";
import logo from "../../assets/images/logo.svg";
import leftIcon from "../../assets/images/chevron-left.svg";
import { showToast } from '../../components/common/toast';
import { useForm } from "react-hook-form";
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";


const ForgotPassword = () => {
  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm();

  const handleForgotPassword = async (formData) => {
    try {
      const response = await commonPostApi("/forgot-password", { email: formData.email });
      if (response?.status === 200) {
        const successMessage = response?.data?.message 
          ? typeof response.data.message === 'string' 
            ? response.data.message 
            : FEATURE_MSG.AUTH.RESET_LINK_SENT
          : FEATURE_MSG.AUTH.RESET_LINK_SENT;
        showToast(TOAST_TYPE.SUCCESS, successMessage);
        navigate("/login")
      } else if (response?.response?.data) {
        const errorMessage = typeof response.response.data === 'object' && response.response.data.message
          ? response.response.data.message
          : typeof response.response.data === 'string'
            ? response.response.data
            : COMMON_MSG.ERROR.GENERIC;
        showToast(TOAST_TYPE.ERROR, errorMessage);
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
    } catch (error) {
      console.error("Error sending reset link:", error);
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  };

  return (
    <div className="Login__main-container">
        <div className="Login__image-sec">
          <img src={loginImage} alt="Login Background" />
        </div>
      <div className="Login__right-section">
        <div className="Login__right-log-sec">
          <img src={logo} alt="Company Logo" />
        </div>
        <div className="Login__right-form-sec">
          <div className="Login__forgot-pwd-sec">
            <div className="Login__right-header-sec">
              <p className="heading">Forgot Password</p>
              <p className="sub-heading">Enter your email and we'll send you instructions to reset your password</p>
            </div>
            <form onSubmit={handleSubmit(handleForgotPassword)}>
              <div className="Login__form-container mt-4">
                <div className="Login__form-control">
                  <InputPrimaryComponents
                    type="text"
                    label="Email Address"
                    errors={errors}
                    control={control}
                    name="email"
                    rules={{ 
                      required: "Email address is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address format"
                      }
                    }}
                    paddingStyle={true}
                    autoFocus={true}
                  />
                </div>
                <div className="Login__login-btn">
                  <Button type="submit" label="Send Reset Link" />
                </div>
                <div className="Login__contact-admin-sec back-to-login">
                  <span className="btn-left-icon">
                    <img src={leftIcon} alt="Back Icon" />
                  </span>
                  <Button link label="Back to Login" onClick={() => navigate("/")} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;